<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import Header from './Header.svelte';
  import Footer from './Footer.svelte';
  import 'bootstrap/dist/css/bootstrap.min.css';
  import './styles.css';
  import { initializeBootstrap } from '$lib/utils/bootstrapUtils';
  import { initializeMatomo } from '$lib/utils/matomoUtils';
  import type { Unsubscriber } from 'svelte/motion';
  import Toast from '$lib/components/Toast.svelte';

  export let data: import('./$types').LayoutData;

  let unsubscribeMatomo: Unsubscriber | undefined;

  onMount(async () => {
    if (typeof window !== 'undefined') {
      await initializeBootstrap();
    }

    unsubscribeMatomo = initializeMatomo();
  });

  onDestroy(() => {
    if (unsubscribeMatomo) {
      unsubscribeMatomo();
    }
  });
</script>

<div class="app d-flex flex-column min-vh-100">
  <Header isBetaAvailable={data.isBetaAvailable} />

  <main class="flex-grow-1">
    <slot />
  </main>

  <Footer />
  <Toast />
</div>
